import { useEffect, useState, useContext } from "react";

import { LayoutContext } from "../layout/";
import Toast from '../toast';
import Loader from "../loader";
import { getEndpoint } from "../helper";

import "./profile.scss";

export default function Profile(props) {
    const { mobile, setPageTitle } = useContext(LayoutContext);

    const [profile, setProfile] = useState({});
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [showToast, setShowToast] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});

    const handleInputChange = (e, propName) => {
        const { firstName, lastName, cardNumber } = profile;

        setProfile({ ...profile, [propName]: e.target.value });
    }

    const handleClick = async () => {
        const newErrors = {};
        for (let key in profile) {
            if (!profile[key].trim()) newErrors[key] = true;
        }
        setValidationErrors(newErrors);

        try {
            const res = await fetch(getEndpoint("/api/android/user/update"), {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ username: mobile, ...profile })
            });

            if (!res.ok) {
                throw new Error(`HTTP error! status: ${res.status}`);
            }

            setShowToast(true);
            setTimeout(() => setShowToast(false), 4000);
        } catch (err) {
            setError(err.message);
        }
    }

    useEffect(() => {
        setPageTitle('پروفایل');

        const controller = new AbortController();
        const { signal } = controller;

        const fetchSequential = async () => {
            try {
                const profileRes = await fetch(getEndpoint(`/api/android/user/get?username=${mobile}`), { signal });
                const profileData = await profileRes.json();

                setProfile(profileData.data);
            } catch (err) {
                if (err.name !== "AbortError") setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchSequential();

        return () => controller.abort();
    }, []);

    if (loading) return <Loader />;
    if (error) return <p>Error: {error}</p>;

    return (
        <>
            <div className="profile p-4 d-f fd-c h-100">
                <img src={getEndpoint('/pwa/img/logo.png')} className='mx-a mt-4' style={{ width: '8.5rem' }} />
                <div className='ta-c my-5'>در این قسمت می توانید اطلاعات خود را تکمیل کنید</div>
                <div className='input d-f ai-c bc-w px-2 mb-4 br-4'>
                    <div className='us-n' children={mobile} />
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32" fill='#9d9d9d' className='mr-a'>
                        <path d="M21.313 22.469v-18.688h-12v18.688h12zM15.313 27.781q0.813 0 1.406-0.594t0.594-1.406-0.594-1.406-1.406-0.594-1.406 0.594-0.594 1.406 0.594 1.406 1.406 0.594zM20.688-0.219q1.375 0 2.344 1t0.969 2.375v22.625q0 1.375-0.969 2.375t-2.344 1h-10.688q-1.375 0-2.344-1t-0.969-2.375v-22.625q0-1.375 0.969-2.375t2.344-1h10.688z"></path>
                    </svg>
                </div>

                <div className={`input d-f ai-c bc-w px-2 mb-4 br-4 ${validationErrors.firstName ? '' : ''}`}>
                    <input
                        type="text"
                        className='f:o-n w-100 bc-t'
                        placeholder='نام'
                        value={profile.firstName || ''}
                        onChange={e => handleInputChange(e, 'firstName')}
                    />
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32" fill='#9d9d9d' className='mr-a'>
                        <path d="M16 17.156q3.375 0 7.031 1.469t3.656 3.844v2.688h-21.375v-2.688q0-2.375 3.656-3.844t7.031-1.469zM16 14.469q-2.188 0-3.75-1.563t-1.563-3.75 1.563-3.781 3.75-1.594 3.75 1.594 1.563 3.781-1.563 3.75-3.75 1.563z"></path>
                    </svg>
                </div>

                <div className='input d-f ai-c bc-w px-2 mb-4 br-4'>
                    <input
                        type="text"
                        className='f:o-n w-100'
                        placeholder='نام خانوادگی'
                        value={profile.lastName || ''}
                        onChange={e => handleInputChange(e, 'lastName')}
                    />
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32" fill='#9d9d9d' className='mr-a'>
                        <path d="M21.313 15.781q1.75 0 3.813 0.5t3.813 1.625 1.75 2.563v3.313h-8v-3.313q0-2.75-2.625-4.625 0.438-0.063 1.25-0.063zM10.688 15.781q1.75 0 3.813 0.5t3.781 1.625 1.719 2.563v3.313h-18.688v-3.313q0-1.438 1.75-2.563t3.813-1.625 3.813-0.5zM10.688 13.156q-1.625 0-2.813-1.188t-1.188-2.813 1.188-2.813 2.813-1.188 2.781 1.188 1.156 2.813-1.156 2.813-2.781 1.188zM21.313 13.156q-1.625 0-2.813-1.188t-1.188-2.813 1.188-2.813 2.813-1.188 2.813 1.188 1.188 2.813-1.188 2.813-2.813 1.188z"></path>
                    </svg>
                </div>

                <div className='input d-f ai-c bc-w px-2 br-4'>
                    <input
                        type="text"
                        className='f:o-n w-100'
                        placeholder='شماره کارت'
                        value={profile.cardNumber || ''}
                        onChange={e => handleInputChange(e, 'cardNumber')}
                    />
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32" fill='#9d9d9d' className='mr-a'>
                        <path d="M26.688 9.156v-2.688h-21.375v2.688h21.375zM26.688 22.469v-8h-21.375v8h21.375zM26.688 3.781q1.125 0 1.875 0.781t0.75 1.906v16q0 1.125-0.75 1.906t-1.875 0.781h-21.375q-1.125 0-1.875-0.781t-0.75-1.906v-16q0-1.125 0.75-1.906t1.875-0.781h21.375z"></path>
                    </svg>
                </div>

                <button className='_bc-g c-w w-100 py-2 br-4 mt-a' onClick={handleClick}>ذخیره تغییرات</button>
            </div>
            <Toast show={showToast} message='درخواست شما با موفقیت انجام شد.' />
        </>
    );
}